import React from "react";
import { withRouter, Link } from "react-router-dom";
import queryString from "query-string";
import { connect } from "react-redux";
import stage_01 from "../../assets/images/stage_01.png";
import stage_02 from "../../assets/images/stage_02.png";
import stage_03 from "../../assets/images/stage_03.png";
import { ReactComponent as ArrowLeft } from "../../assets/svg/arrow_left-icon.svg";
import { ReactComponent as ArrowRight } from "../../assets/svg/arrow_right-icon.svg";
import { ReactComponent as RedoIcon } from "../../assets/svg/redo-icon.svg";
import "./_Footer.scss";

class Footer extends React.Component {
  renderStage = () => {
    const currentView = this.getCurrentView();
    switch (currentView) {
      case "/":
        return (
          <img className="stage-indicator" src={stage_01} alt="stage one" />
        );
      case "collection":
        return (
          <img className="stage-indicator" src={stage_02} alt="stage two" />
        );
      case "collection-necklace":
        return (
          <img className="stage-indicator" src={stage_02} alt="stage two" />
        );
      case "digital-showroom":
        return (
          <img className="stage-indicator" src={stage_03} alt="stage three" />
        );
      case "digital-showroom-necklace":
        return (
          <img className="stage-indicator" src={stage_03} alt="stage three" />
        );
      default:
        return;
    }
  };

  renderBackButton = (backButtonText) => {
    const { history } = this.props;
    const currentView = this.getCurrentView();
    let route = null;
    let arrowLeftClass = "arrow arrow-left petrol";
    switch (currentView) {
      case "/":
        break;
      case "digital-showroom":
        route = "/?view=collection";
        break;
      case "digital-showroom-necklace":
        route = "/?view=collection-necklace";
        break;
      case "summary":
        route = history
          ? history.location.search.replace("summary", "digital-showroom")
          : "/?view=digital-showroom";
        arrowLeftClass = "arrow arrow-left light-blue";
        break;
      case "summary-necklace":
        route = history
          ? history.location.search.replace(
              "summary-necklace",
              "digital-showroom-necklace"
            )
          : "/?view=digital-showroom";
        arrowLeftClass = "arrow arrow-left light-blue";
        break;
      case "collection":
        route = "/";
        break;
      case "collection-necklace":
        route = "/";
        break;
      default:
        break;
    }
    if (route) {
      return (
        <Link className="arrow-button" to={route}>
          <ArrowLeft className={arrowLeftClass} />
          {backButtonText}
        </Link>
      );
    }
  };

  renderForwardButton = (buttonText) => {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    if (queryParams) {
      if (
        queryParams.view === "digital-showroom" ||
        queryParams.view === "digital-showroom-necklace"
      ) {
        return (
          <button
            className="arrow-button"
            onClick={() => this.onForwardButtonPress()}
          >
            {buttonText}
            <ArrowRight className="arrow arrow-right petrol" />
          </button>
        );
      }
    }
  };

  onForwardButtonPress = () => {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    if (queryParams && queryParams.view) {
      if (queryParams.view === "digital-showroom-necklace") {
        queryParams.view = "summary-necklace";
        history.push({
          pathname: "/",
          search: queryString.stringify(queryParams),
        });
      } else {
        queryParams.view = "summary";
        history.push({
          pathname: "/",
          search: queryString.stringify(queryParams),
        });
      }
    }
  };

  getCurrentView = () => {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    if (queryParams && queryParams.view) {
      return queryParams.view;
    }
    return "/";
  };

  renderRedoButton = (text) => {
    return (
      <Link className="redo-button icon-button" to="/">
        <RedoIcon className="redo-icon icon" />
        {text}
      </Link>
    );
  };

  render() {
    const {
      backButtonText = "",
      forwardButtonText = "",
      redoButtonText,
    } = this.props;
    const currentView = this.getCurrentView();
    if (currentView === "summary" || currentView === "summary-necklace") {
      return (
        <div className="footer summary-footer">
          {this.renderRedoButton(redoButtonText)}
          {this.renderBackButton(backButtonText)}
        </div>
      );
    }

    return (
      <div className="footer">
        {this.renderBackButton(backButtonText)}
        {this.renderStage()}
        {this.renderForwardButton(forwardButtonText)}
      </div>
    );
  }
}

const mapStateToProps = ({ configuratorPage }) => {
  const { activeMainRing, activeHolderRing } = configuratorPage;

  return {
    activeMainRing,
    activeHolderRing,
  };
};

export default connect(mapStateToProps, {})(withRouter(Footer));
